import { openDialog } from "@/src/components/dialogs";
import { Input } from "@/src/components/universalInput";
import { USER } from "@/src/data/globalVariables";
import apiFetch from "@/src/utils/apiFetch";
import { useState } from "react";

function NoLicenceDialog({
  current,
  onChang,
}: {
  current: string;
  onChang: (newValue: string) => void;
}) {
  const [licence, setLicence] = useState<string>("");
  function localOnChange(newValue: string) {
    setLicence(newValue);
    onChang(newValue);
  }
  return (
    <div>
      <div className="gray center">
        Vous avez atteint le nombre maximal de patients pour la version
        gratuite.
        <br /> Veuillez entrer votre code de licence.
        <br /> Pour obtenir un code de licence, veuillez contacter le 0799 11 25
        05
      </div>
      <div className="">
        <Input
          name={"Code de licence"}
          placeholder="Ex: AX27A-7161HB-AHAHD4"
          value={licence}
          type="text"
          onChange={(newValue) => {
            localOnChange(newValue);
          }}
        ></Input>
      </div>
    </div>
  );
}

export async function openMaxPatientsDialog() {
  let licence = "";
  return await openDialog({
    id: "noLicenceDialog",
    title: "Veuillez introduire votre code de licence",
    content: (
      <NoLicenceDialog
        current={licence}
        onChang={(newValue) => {
          licence = newValue;
        }}
      />
    ),
    onConfirm: async () => {
      await apiFetch("users", "addLicence", {
        licence,
        userId: USER.get()?.id,
      });
      window.location.href = "/";
    },
  });
}
